<template>
<div>
<div class="modal modal-mask" style="display: block" id="fiscal_printer" tabindex="-1" role="dialog">
<div class="modal-dialog modal-dialog-centered" role="document">
<div class="modal-content">
<div  style="background-color:#9acd32;color:black" class="modal-header text-nowrap ">
  
    <h4 class="modal-title ">
    
     <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
      
     <span v-if="creditNote.form && !giftTicket">NOTA DI CREDITO</span>
    <span v-else><strong>{{getType()}}  </strong></span>
    </h4>  
    <hr>
   <!-- <h6> {{rt.url}} {{rt.type}} {{rt.badge}}</h6>-->
    
    
   
</div>

<div class="modal-body">

  <!--
  <div v-show="giftTicket == false && !creditNote.form ">  
    <label class="control-label" for="lottery">  
    <strong><i style="color:#ff00ff" class="fas fa-qrcode mr-2" aria-hidden="true"></i>CODICE LOTTERIA</strong></label>  
    <input v-focus v-model="lottery" type="text" class="form-control" placeholder=""  id="lottery">    
  </div>  
  -->
  
  <component ref="rt" @finish="close" v-bind:notFiscal="notFiscal" v-bind:giftTicket="giftTicket" v-bind:is="component" v-bind:url="rt.url" v-bind:driver="rt.driver" v-bind:data="data"  v-if="component" />
  <ditron_cn_form ref="ditron_cn_form" @update="setData" v-if="creditNote.form && !giftTicket && component=='ditron'"></ditron_cn_form>
  <epson_cn_form @setButton="setButton"  v-bind:fiscalReceiptSaleId="fiscalReceiptSaleId" ref="epson_cn_form" @update="setData" v-if="creditNote.form && !giftTicket && component=='epson'"></epson_cn_form>

</div>    
<div class="modal-footer">

  <button @click="$emit('close')" type="button" class="btn btn-outline-secondary float-left">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA</button>
        <button v-if="btn" @click="printData()" :disabled="spinner==true" type="button" class="btn btn-primary float-right">
        <i class="fas fa-print mr-2" aria-hidden="true"></i>   
        STAMPA
         <span v-if="spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
        </button>
    
</div>
</div>
</div>
</div>
  
</div>

</template>

<script>
import { mapGetters }     from 'vuex';
import api                from "@/api";

import ditron             from '@/components/rt/Ditron.vue'
import rch                from '@/components/rt/Rch.vue'
import epson              from '@/components/rt/Epson.vue'
import retail             from '@/components/rt/Retail.vue'
import ditron_cn_form     from '@/components/rt/DitronCreditNoteForm.vue'
import ela                from '@/components/rt/Ela.vue'
import epson_cn_form      from '@/components/rt/EpsonCreditNoteForm.vue'

export default {

  props : ['saleId','deskId','giftTicket','coupon','notFiscal','fiscalReceiptSaleId'],

  components: {ditron,rch,epson,retail,ditron_cn_form,ela,epson_cn_form},
  data() {
    return {

      spinner    : false,
      rt         : {},
      component  : '',
      lottery    : '',
      rt         : {},
      data       : {},

      creditNote : {},
      rt_badge   : '',
      btn        : true
      
            
    };
  },
    directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        
        
        el.focus();
      }
    }
  },
  computed:
    {
       ...mapGetters(['storeId','company']) 
    },
  created () 
    { 
         
          if(this.coupon)
          {
            console.log('PRINT FISCAL COUPON ')
            this.rt.url    = ''
            this.data.data = this.coupon            
            this.component = 'epson'

          }
          else
          {
            this.getStoreRT()  
          }
          
          
      },  
  methods: 
    {
    setButton(btn)  
    {
      this.btn = btn
    },
    getType()
    {
      if(this.giftTicket)
      {
        return 'SCONTRINO DI CORTESIA'
      }
      if(this.notFiscal)
      {
        return 'DOCUMENTO GESTIONALE'
      }
      return 'SCONTRINO FISCALE'
    },
    setData(data)
    {

      this.data.creditNote = data
      this.data.creditNote.rt_badge = this.rt_badge
      this.spinner = true
      

      this.$refs.rt.clickHandler()

    },
    close()
    {
      this.component = ''
      this.$emit('finish')
      
    },

    
    printData()
    {   
        
        this.data.lottery = this.lottery
        
        if(this.giftTicket && this.creditNote.form == true)
        {
          return
        }

        if(this.creditNote.form & this.component == 'ditron')
        {                              
          this.$refs.ditron_cn_form.checkData()
          return
        }
        if(this.creditNote.form & this.component == 'epson')
        {                              
          this.$refs.epson_cn_form.checkData()
          return
        }

        // UPDATE FISCAL STATUS PRINT        
        const Id = this.saleId ? this.saleId : this.coupon.Id
        const type = this.saleId ? 'sale' : 'coupon'
        console.log('nota di credito Id',Id)

        if(!this.giftTicket && !this.notFiscal)
        {
          this.updateFiscalPrintStatus(Id,type)
        }

        this.spinner = true
        this.$refs.rt.clickHandler()


    },

    async getDataToPrint()
    {
            
            const sp       = {'sp'     :'spFiscalTicketData'}      
            const data     = {'saleId' : this.saleId,'type':this.component}
            const json     = Object.assign(data, sp);

            await api.post(json).then(res =>{
            
            this.data     = {'data' : res.data.recordsets,'saleId':this.saleId}  
          
            this.data.data[0].forEach(item => {
             
              if(item.rowType != 0 )
              {

                this.creditNote.form = true
              }
              
            });
                                  
                    
          })
        },
    async updateFiscalPrintStatus(Id,type)
    {
            
            const sp       = {'sp'       :'spUpdateFiscalPrintStatus'}      
            const data     = {'type'     : type,'Id':Id }
            const json     = Object.assign(data, sp);

            await api.post(json).then(res =>{
              if(res.status==200)
              {
            
                  //console.log(res)

              }
              else if(res.status==500)
              {
                console.log(res.data)
              }
              else
              {
                console.log(res)
              }
                                  
                    
          })
        },
     
    async getStoreRT()
    {
      var sp    = {'sp':'spStoreRT'}
      var data  = {'storeId' : this.storeId,'deskId':this.deskId}
      
      var json  = Object.assign(data, sp);
      
      await api.post(json).then(res => {
        if(res.status==200)
          {

            if(res.data.recordsets[0].length>0)
            {  
              this.rt =  res.data.recordsets[0][0]
              console.log(this.rt)
            }
            if(this.rt)
            {
              this.component = this.rt.type
              this.rt_badge = this.rt.badge
             
              this.getDataToPrint()
            }

          }
          else if(res.status==500)
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '                       
            this.msg.body = res
            this.msg.type = 1                
          } 
      }).catch(err => 
      {
      
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1           
      }).finally(() => {
        //this.spinner = false
      });

    

    }
  }
    
   
}


</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;  
}
small {
  font-family  : 'Roboto Condensed';
  font-size    : 15px;
}




.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}


.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}


.modal-footer {  
  justify-content: space-between;  
}
</style>


